<template>
  <div id="page">
    <div v-if="isUpdate == 0">
      <van-nav-bar
        title="我要成团"
        left-text=""
        left-arrow
        @click-left="onClickLeft()"
      >
      </van-nav-bar>
      <div style="margin-top: 10px">
        <van-field
          v-model="Name"
          label="团队名"
          name="团队名"
          placeholder="团队名"
          :rules="[{ required: true, message: '请填写团队名' }]"
        />
        <!-- <van-notice-bar
          wrapable
          :scrollable="false"
          style="color:red;"
          text="温馨提示：以团长身份创建团队成功后不能退出该团，请谨慎操作！"
        /> -->
        <div style="margin: 16px">
          <van-button round block type="info" @click="CreateTeam"
            >提交</van-button
          >
        </div>
      </div>
    </div>
    <div v-else>
      <van-nav-bar
        title="更改团名"
        left-text=""
        left-arrow
        @click-left="onClickLeft()"
      >
      </van-nav-bar>
      <div style="margin-top: 10px">
        <van-field
          v-model="Name"
          label="团队名"
          name="团队名"
          placeholder="团队名"
          :rules="[{ required: true, message: '请填写新的团队名' }]"
        />
        <div style="margin: 16px">
          <van-button round block type="info" @click="UpdateTeam"
            >提交</van-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { NavBar, Button, Field, NoticeBar, Dialog } from "vant";
export default {
  data() {
    return {
      isUpdate: 0,
      Name: "",
    };
  },
  created() {
    this.isUpdate = this.$route.params.update;
    console.log(this.$route.params.update);
  },
  methods: {
    onClickLeft() {
      this.$router.back(-1);
    },
    UpdateTeam(){
      var that=this;
      if(that.Name == ""){
        return this.$toast.fail("团名不可以为空");
      }
      that.$http
        .get("Team/UpdateTeam", {
          params: { teamName: that.Name },
        })
        .then((res) => {
          if (res.data == "success") {
            that.$toast("操作成功");
            that.$router.back(-1);
          } else {
            that.$toast(res.data);
          }
        });
    },
    CreateTeam() {
      var that = this;
      Dialog.confirm({
        title: "成团提示",
        message:
          "以团长身份创建团队成功后不能退出该团，是否确认成团?",
      })
        .then(() => {
          // on confirm
          that.$http
          .get("Team/CreateTeam", {
            params: { teamName: that.Name },
          })
          .then((res) => {
            if (res.data == "success") {
              that.$toast("操作成功");
              that.$router.back(-1);
            } else {
              that.$toast(res.data);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
  components: {
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [Field.name]: Field,
    [NoticeBar.name]: NoticeBar,
    [Dialog.name]: Dialog,
  },
};
</script>
<style scoped>
html {
  background: #f12416;
}
#page {
  width: 100%;
  height: 100%;
}
.indexPage {
  width: 100%;
  height: 100%;
  background-image: url("../assets/draw3/index.jpg");

  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-content: space-around;
  justify-content: center;
  flex-wrap: wrap;
}
.mockTap {
  width: 280px;
  height: 280px;
  padding-top: 70px;
}
.step {
  z-index: 999;
}

.bounce-in-top {
  -webkit-animation: bounce-in-top 1.2s ease-in both;
  animation: bounce-in-top 1.2s ease-in both;
}
/* ----------------------------------------------
 * Generated by Animista on 2021-9-5 1:36:2
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation bounce-in-top
 * ----------------------------------------
 */
@-webkit-keyframes bounce-in-top {
  0% {
    -webkit-transform: translateY(-500px);
    transform: translateY(-500px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 0;
  }
  38% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
    opacity: 1;
  }
  55% {
    -webkit-transform: translateY(-65px);
    transform: translateY(-65px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  72% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  81% {
    -webkit-transform: translateY(-28px);
    transform: translateY(-28px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  90% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  95% {
    -webkit-transform: translateY(-8px);
    transform: translateY(-8px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
}
@keyframes bounce-in-top {
  0% {
    -webkit-transform: translateY(-500px);
    transform: translateY(-500px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 0;
  }
  38% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
    opacity: 1;
  }
  55% {
    -webkit-transform: translateY(-65px);
    transform: translateY(-65px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  72% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  81% {
    -webkit-transform: translateY(-28px);
    transform: translateY(-28px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  90% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  95% {
    -webkit-transform: translateY(-8px);
    transform: translateY(-8px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
}
</style>
